import React from "react";
import ReactImageMagnify from "react-image-magnify";

const MyReactImageMagnify = ({ image }) => {
  return (
    <div className="magnify_wrapper">
      <ReactImageMagnify
        smallImage={{
          alt: "product",
          isFluidWidth: true,
          src: image,
          className : "product_img"
        }}
        largeImage={{
          src: image,
          width: 1500,
          height: 1100,
        }}
        enlargedImagePosition="over"
        enlargedImageContainerDimensions={{
          width: "100%",
          height: "100%",
        }}
        enlargedImageContainerStyle={{
          background: "#000",
          zIndex: 999,
        }}
      />
    </div>
  );
};

export default MyReactImageMagnify;